'use strict';

module.exports = {
    CURRENCY_CHANGED: 'currency:changed',
    CURRENCY_LOADED: 'currency:loaded',
};



// WEBPACK FOOTER //
// ./assets/js/global/constants/currencyActionConstants.es.js